import React from 'react';
import './ToggleSwitch.css';

/**
 * A reusable iOS-style toggle switch component.
 *
 * @param {Object} props
 * @param {boolean} props.checked - Current checked state
 * @param {function} props.onChange - Callback fired when state changes
 * @param {string} [props.label] - Optional label text to display next to the switch
 * @param {boolean} [props.disabled=false] - Whether the switch is disabled
 * @param {'sm' | 'md'} [props.size='md'] - Size variant
 * @param {string} [props.className] - Additional CSS classes
 */
const ToggleSwitch = ({
  checked,
  onChange,
  label,
  disabled = false,
  size = 'md',
  className = ''
}) => {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <label className={`toggle-switch-container ${size} ${disabled ? 'disabled' : ''} ${className}`}>
      <input
        type="checkbox"
        className="toggle-checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <span className="toggle-slider"></span>
      {label && <span className="toggle-label">{label}</span>}
    </label>
  );
};

export default ToggleSwitch;
